export const MAX_PHOTOS_IN_COLLAGE = 8;

export const PHOTO_COLLAGE_ROWS_GAP = 12;
